<template>
  <div :class="[className, 'elemTextarea']">
    <label :for="fieldId">
      {{ label }}
    </label>
    <textarea :disabled="disabled" :id="fieldId" v-model="value" />
    <span class="error">{{ error }}</span>
  </div>
</template>

<script>
// Сквозной счётчик, чтобы у каждого поля на странице был свой id
let instanceCount = 0;

export default {
  name: "elemTextarea",
  props: {
    disabled: {
      default: false,
    },
    elId: {
      default: null,
    },
    label: {
      default: null,
    },
    error: {
      default: null,
    },
    valueName: {
      default: null,
    },
    valueProp: {
      default: null,
    },
    className: {
      default: null,
    },
  },
  data() {
    return {
      value: null,
      uid: ++instanceCount,
    };
  },
  computed: {
    fieldId() {
      return this.elId || "elemTextarea-" + this.uid;
    },
  },
  watch: {
    valueProp(value) {
      this.value = value;
    },
    value(value) {
      this.$emit("changeValue", this.valueName, value);
    },
  },
  methods: {},
  created() {
    this.value = this.valueProp;
  },
};
</script>
